import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home/Home'; //首页
import AboutUs from '@/components/aboutUs/AboutUs' //关于我们
import ContactUs from '@/components/contactUs/ContactUs' //联系我们
import News from '@/components/news/News' //新闻 1
import NewsDetail from '@/components/newsDetail/NewsDetail' //新闻详情 1
import Pay from '@/components/pay/Pay'
import PayPage from '@/components/pay/PayPage' //
import modifyPsd from '@/components/modifyPsd/modifyPsd' //修改密码
import Register from '@/components/register/Register' //注册 1
import ShopCar from '@/components/shopCar/ShopCar' //购物车
import SubmitOrder from '@/components/shopCar/SubmitOrder'; //购物车提交订单
import TgShare from '@/components/tgShare/TgShare' //技术分享 1

import Login from '@/components/login/Login' //首页
import Order from '@/components/order/Order' //提交订单
import OrderDetail from '@/components/memberCenter/order/OrderDetail' //订单详情
import AllOrder from '../components/memberCenter/order/AllOrder'; //所有订单
import MemberCenter from '@/components/memberCenter/MemberCenter' //我的汉芯
import MemberCenterDetail from "@/components/memberCenter/MemberCenterDetail" //我的汉芯 ，个人中心

import CustomizedApply from '../components/customized/Apply'; //定制服务

import MyMessage from '../components/memberCenter/message/MyMessage'; //我的消息
import GoodsCenter from '@/components/goodsCenter/GoodsCenter' //产品中心
import GoodsDetails from '@/components/goodsCenter/GoodsDetails' //产品详情
import ProductSearch from '@/components/search/ProductSearch' //产品搜索
import MyBalance from '../components/memberCenter/balance/MyBalance' //我的余额

import CollectionAll from '../components/memberCenter/collection/CollectionAll'; //我的收藏
import RemoteTechnology from '../components/memberCenter/remoteTechnology/RemoteTechnology'; //我的远程技术支持
import CashOrCharge from '../components/pay/CashOrCharge'; //充值提现


import MyProject from "../components/memberCenter/myProject/MyProject";
import FootPrint from "../components/memberCenter/footPrint/FootPrint";
import service from "../components/service/service";
import Error from "../components/fourOneFour/fourOneFour"
import solution from "../components/solution/solution"


import privacy from "../components/privacy/privacy"

// import

Vue.use(Router);

export default (function() {

	let routes = [
		// 解决方案
		...[{
			path: '/solution',
			name: 'solution',
			component: solution
		}],
		// 404
		...[{
			path: '*',
			name: 'service',
			component: Error
		}],
		//售后服务
		...[{
			path: '/service',
			name: 'service',
			component: service
		}],
		//关于我们，联系我们
		...[{
				path: '/aboutUs',
				name: 'AboutUs',
				component: AboutUs
			},
			{
				path: '/contactUs',
				name: 'ContactUs',
				component: ContactUs
			}
		],
		//新闻资讯
		...[{
				path: '/news',
				name: 'News',
				component: News
			},
			{
				path: '/newsDetail',
				name: 'NewsDetail',
				component: NewsDetail
			}
		],
		//支付
		...[{
				path: '/pay',
				name: 'Pay',
				component: Pay
			},
			{
				path: '/payPage',
				name: 'PayPage',
				component: PayPage
			},
			{
				path: '/cash/charge',
				name: 'CashOrCharge',
				component: CashOrCharge
			}
		],
		//我的
		...[{
				path: '/footPrint/all',
				name: 'FootPrint',
				component: FootPrint
			},
			{
				path: '/membercenter',
				name: 'MemberCenter',
				component: MemberCenter
			},
			{
				path: '/memberCenterDetail',
				name: 'MemberCenterDetail',
				component: MemberCenterDetail,
				meta: {
					requiresAuth: true
				} //二级页面做登录校验
			},
			{
				path: '/mine/message',
				name: 'MyMessage',
				component: MyMessage,
				// meta: {requiresAuth: true}
			},
			{
				path: '/all/order',
				name: 'AllOrder',
				component: AllOrder
			},
			{
				path: '/balance/MyBalance',
				name: 'MyBalance',
				component: MyBalance
			},
			{
				path: '/myProject/MyProject',
				name: "MyProject",
				component: MyProject
			},
			{
				path: '/collection/all',
				name: 'CollectionAll',
				component: CollectionAll
			},
			{
				path: '/remote/technology',
				name: 'RemoteTechnology',
				component: RemoteTechnology
			}
		],
		//定制服务相关
		...[{
			path: '/customized/Apply',
			name: 'CustomizedApply',
			component: CustomizedApply
		}],
		//订单
		...[{
				path: '/shopCar',
				name: 'ShopCar',
				component: ShopCar
			},
			{
				path: '/submit/order',
				name: 'SubmitOrder',
				component: SubmitOrder
			},
			{
				path: '/order',
				name: 'Order',
				component: Order
			},
			{
				path: "/order/orderDetail",
				name: "OrderDetail",
				component: OrderDetail
			}
		],
		//首页，登录注册等其他页面
		...[{
				path: '/',
				name: 'Home',
				component: Home
			},
			{
				path: '/login',
				name: 'Login',
				component: Login
			},
			{
				path: '/modifyPsd',
				name: 'modifyPsd',
				component: modifyPsd
			},
			{
				path: '/register',
				name: 'Register',
				component: Register
			},
			{
				path: '/tgShare',
				name: 'TgShare',
				component: TgShare
			},
			{
				path: '/goodsCenter',
				name: 'GoodsCenter',
				component: GoodsCenter
			},
			{
				path: '/goodsdetails',
				name: 'GoodsDetails',
				component: GoodsDetails
			},
			{
				path: '/privacy',
				name: 'privacy',
				component: privacy
			}
			
		],
		...[{
			path: '/searchAll',
			name: 'ProductSearch',
			component: ProductSearch
		}]
	];

	//路由
	return new Router({routes});
}());



// WEBPACK FOOTER //
// ./src/router/index.js